import React, { useEffect, useState } from "react";
import {
  Layout,
  Table,
  Card,
  Button,
  Space,
  Tag,
  Image,
  Popconfirm,
  Modal,
  message,
  Select,
  Typography
} from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import Sidebar from "../../Components/Sidebar";
import { BASE_URL } from "../../Config/index";
import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Option } = Select;
const { Text: AntText } = Typography;

const AllMakeVariation = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [variations, setVariations] = useState([]);
  const [loading, setLoading] = useState(true);

  const [viewModal, setViewModal] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState(null);

  useEffect(() => {
    fetchVariations();

    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const fetchVariations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/makevariations`);

      const data = res.data?.data || res.data || [];

      setVariations(Array.isArray(data) ? data : []);

    } catch (error) {
      console.log(error);
      message.error("Failed to fetch variations");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`${BASE_URL}/makevariations/${id}`);

      if (res.data.success) {
        message.success("Variation deleted");
        fetchVariations();
      } else {
        message.error("Delete failed");
      }
    } catch (error) {
      console.log(error);
      message.error("Error while deleting");
    }
  };

  const handleView = async (record) => {
    setSelectedInfo(record);
    setViewModal(true);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "variationImage",
      render: (img) => (
        <Image
          src={img}
          width={70}
          height={70}
          style={{ borderRadius: 6, objectFit: "cover" }}
        />
      ),
    },
    {
      title: "Variation Name",
      dataIndex: "variationName",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Sanskrit",
      dataIndex: "sanskrit",
    },
    {
      title: "Variation Type",
      dataIndex: "variationType",
      render: (arr) =>
        arr?.map((t, i) => (
          <Tag color="blue" key={i}>
            {t}
          </Tag>
        )),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          {/* View Popup */}
          <Button icon={<EyeOutlined />} onClick={() => handleView(record)} />

          {/* Edit */}
          <Button
            icon={<EditOutlined />}
            type="primary"
            onClick={() =>
              (window.location.href = `/edit-variations/${record._id}`)
            }
          />

          {/* Delete */}
          <Popconfirm
            title="Are you sure you want to delete this?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const MobileVariationCard = ({ item }) => {
    return (
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 16,
        }}
        bodyStyle={{ padding: 16 }}
      >
        {/* Top Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <span style={{ color: "#888", fontWeight: 500 }}>
            {item.asanaType?.toUpperCase()}
          </span>

          <Tag
            style={{
              borderRadius: 20,
              padding: "2px 12px",
            }}
            color="green"
          >
            ● {item.asanaType}
          </Tag>
        </div>

        {/* Title */}
        <div
          style={{
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          {item.variationName}
        </div>

        {/* Subtitle */}
        <div
          style={{
            color: "#777",
            marginBottom: 12,
          }}
        >
          {item.english}
        </div>

        {/* Bottom Info */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div>
            <div style={{ color: "#888" }}>Created on</div>
            <div>
              {item.createdAt
                ? new Date(item.createdAt).toLocaleDateString()
                : "-"}
            </div>
          </div>

          <div>
            <div style={{ color: "#888" }}>Level</div>
            <div>{item.asanaType}</div>
          </div>
        </div>

        {/* Buttons */}
        <Space>
          <Button onClick={() => handleView(item)}>
            View
          </Button>

          <Button
            type="primary"
            onClick={() =>
            (window.location.href =
              `/edit-variations/${item._id}`)
            }
          >
            Edit
          </Button>

          <Popconfirm
            title="Delete variation?"
            onConfirm={() =>
              handleDelete(item._id)
            }
          >
            <Button danger>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      </Card>
    );
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}

        collapsedWidth="0"
        role="admin"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >

        <Header className="MainHeader">

          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}

          <div style={{ flex: 1 }}>
            <AntText
              style={{
                fontSize: 20,
                fontWeight: "bold"
              }}
            >
              All Make Variation
            </AntText>
          </div>

        </Header>
        <Card title="All Variations" style={{ margin: 20 }}>
          {
            isMobile ? (

              variations.map((item) => (
                <MobileVariationCard
                  key={item._id}
                  item={item}
                />
              ))

            ) : (

              <Table
                columns={columns}
                dataSource={variations}
                rowKey="_id"
                loading={loading}
                pagination={{ pageSize: 5 }}
              />

            )
          }
        </Card>
      </Layout>

      {/* =========== VIEW MODAL =========== */}
      <Modal
        open={viewModal}
        onCancel={() => setViewModal(false)}
        title="Variation Details"
        footer={null}
        width={600}
      >
        {selectedInfo && (
          <div>
            <Image
              src={selectedInfo.variationImage}
              width={200}
              style={{ borderRadius: 8, marginBottom: 20 }}
            />

            <p>
              <strong>Name:</strong> {selectedInfo.variationName}
            </p>

            <p>
              <strong>Sanskrit:</strong> {selectedInfo.sanskrit}
            </p>

            <p>
              <strong>Example Asana:</strong> {selectedInfo.exampleAsana}
            </p>

            <p>
              <strong>English:</strong> {selectedInfo.english}
            </p>

            <p>
              <strong>Variation Type:</strong>
            </p>

            {selectedInfo.variationType?.map((tag, i) => (
              <Tag color="purple" key={i}>
                {tag}
              </Tag>
            ))}
          </div>
        )}
      </Modal>
    </Layout>
  );
};

export default AllMakeVariation;
